
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, Headphones } from "lucide-react";

interface PodcastProps {
  podcast: {
    title: string;
    description: string;
    episode_id: string;
    date: string;
    tags: string[];
  };
}

const PodcastCard = ({ podcast }: PodcastProps) => (
  <Card className="mb-4 overflow-hidden hover:shadow-md transition-shadow">
    <CardHeader className="pb-2">
      <div className="flex justify-between items-start">
        <div>
          <CardTitle className="text-lg text-foreground">{podcast.title}</CardTitle>
          <CardDescription className="text-sm text-muted-foreground">{podcast.description}</CardDescription>
        </div>
        <Badge variant="secondary" className="text-xs">
          <Headphones size={14} className="mr-1" />
          Podcast
        </Badge>
      </div>
    </CardHeader>
    <CardContent>
      <iframe 
        src={`https://open.spotify.com/embed/episode/${podcast.episode_id}`} 
        width="100%" 
        height="152" 
        frameBorder="0" 
        allow="encrypted-media"
        className="mb-3"
      ></iframe>
      <div className="flex flex-wrap gap-2 mt-2">
        {podcast.tags.map((tag: string, i: number) => (
          <Badge key={i} variant="outline" className="text-xs">
            {tag}
          </Badge>
        ))}
      </div>
      <div className="mt-3 text-sm text-muted-foreground flex items-center">
        <Clock size={14} className="mr-1" />
        {podcast.date}
      </div>
    </CardContent>
  </Card>
);

export default PodcastCard;
